import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { FormElementDynamicInputTyped } from '../form-elements';
import { Button } from '@chakra-ui/react';
import {
  IncomeCalculatorDefaultFormFields,
  IncomeCalculatorDefaultRequest
} from '../../../@types/shared/income-calculator';
import { getSharedIncomeCalculatorDefaultValues } from './utils';
import { sharedIncomeCalculatorDefaultFormFields } from './config';
import { API } from '../../../services';

// Define the type for the props
interface SharedIncomeCalculatorDefaultProps {
  toggleIncomeCalculator: (value: string) => void;
}

const SharedIncomeCalculatorDefault: React.FC<SharedIncomeCalculatorDefaultProps> = ({
  toggleIncomeCalculator
}) => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors, isValid, isDirty }
  } = useForm<IncomeCalculatorDefaultFormFields>({
    mode: 'onBlur',
    defaultValues: getSharedIncomeCalculatorDefaultValues()
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const onSubmit = async (data: IncomeCalculatorDefaultFormFields) => {
    setIsLoading(true);
    const body: IncomeCalculatorDefaultRequest = {
      UIT: 0,
      DMK: data.DMK === '1',
      JVA: data.JVA === '1',
      PER: data.PER,
      INK: parseInt(data.INK),
      ORT: parseInt(data.INK)
    };

    const res = await API.post<{ yearlyIncome: string }, IncomeCalculatorDefaultRequest>(
      'calculator/calculateyearlyincome',
      body
    );

    setIsLoading(false);
    toggleIncomeCalculator(res.yearlyIncome);
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormElementDynamicInputTyped<IncomeCalculatorDefaultFormFields>
          formFields={sharedIncomeCalculatorDefaultFormFields}
          id={'PER'}
          register={register}
          errors={errors}
          values={watch()}
          options={{ required: true }}
        />

        <FormElementDynamicInputTyped<IncomeCalculatorDefaultFormFields>
          formFields={sharedIncomeCalculatorDefaultFormFields}
          id={'INK'}
          register={register}
          errors={errors}
          values={watch()}
          options={{ required: true }}
        />

        <FormElementDynamicInputTyped<IncomeCalculatorDefaultFormFields>
          formFields={sharedIncomeCalculatorDefaultFormFields}
          id={'ORT'}
          register={register}
          errors={errors}
          values={watch()}
          options={{ required: true }}
        />

        <FormElementDynamicInputTyped<IncomeCalculatorDefaultFormFields>
          formFields={sharedIncomeCalculatorDefaultFormFields}
          id={'JVA'}
          register={register}
          errors={errors}
          values={watch()}
          options={{ required: true }}
        />

        <FormElementDynamicInputTyped<IncomeCalculatorDefaultFormFields>
          formFields={sharedIncomeCalculatorDefaultFormFields}
          id={'DMK'}
          register={register}
          errors={errors}
          values={watch()}
          options={{ required: true }}
        />

        <div className={`mt-4`}>
          <Button
            type="submit"
            isLoading={isLoading}
            colorScheme="orange"
            loadingText={'Bezig met versturen'}
            isDisabled={false}>
            {!isValid && isDirty ? `Wat moet ik nog invullen?` : `Volgende`}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default SharedIncomeCalculatorDefault;
